<div class="row row-gutters container">
  <div class="col col-xs-12">
    <local-seo-stat-tabs
      [tabs]="localCards"
      [content]="[top10KeywordChart, positionChart, keywordMovementCard]"
    ></local-seo-stat-tabs>
  </div>
</div>

<ng-template #top10KeywordChart>
  <mat-card>
    <mat-card-content>
      <glxy-chart class="chart-container" [config]="top10ChartConfig" [data]="top10ChartData"></glxy-chart>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #positionChart>
  <mat-card>
    <mat-card-content>
      <glxy-chart class="chart-container" [config]="positionChartConfig" [data]="positionChartData"></glxy-chart>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #keywordMovementCard>
  <mat-card>
    <mat-card-content>
      <div class="positions">
        <div class="position">
          <div class="position-title">
            <span class="position-title-name">Keywords Up</span>
          </div>
          <div class="position-value">
            <span>{{ keywordMovement.keywordsUp }}</span>
            <div class="position-subtitle" *ngIf="keywordMovement.ranksUp > 0">
              {{ 'LOCAL_SEO.LOCAL_SEO.BY_RANKS' | translate: { value: keywordMovement.ranksUp } }}
            </div>
          </div>
        </div>

        <div class="position">
          <div class="position-title">
            <span class="position-title-name">Keywords Down</span>
          </div>
          <div class="position-value">
            <span>{{ keywordMovement.keywordsDown }}</span>
            <div class="position-subtitle" *ngIf="keywordMovement.ranksDown > 0">
              {{ 'LOCAL_SEO.LOCAL_SEO.BY_RANKS' | translate: { value: keywordMovement.ranksDown } }}
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
